/*eslint-disable*/
import React, { Component } from "react";
import PropTypes from "prop-types";
import constants from "../../../utils/constants";
import { defineMessages, FormattedMessage } from "react-intl";
import classnames from "classnames";
import styles from "./WitbookingPaymentBridge.scss";
import { parse as queryStringParse } from "query-string";

import { openPopupWindow } from "./utils";
import { redirectOpenerUrl, redirectUrl } from "../../../utils/misc";

export const msgs = defineMessages({
  errorOcurred: {
    id: "room_selection.calendar.errorOcurred",
    description: "Error Ocurred",
    defaultMessage: "An error occurred",
  },
  tryAgain: {
    id: "payNoPainErrorMessage.tryAgain",
    description: "Try again message",
    defaultMessage: "Try Again.",
  },
});
/* TODO: How do we handle locale? */
/*
 * How it works
 * -User clicks on ConfirmReservation
 * -Reservation is created on the backend, client gets success answer
 * -Application detects current device (mobile or desktop)
 *   if desktop opens new browser windows with THIS component (special route just for it (a.k.a. WITBOOKING_PAYMENT_ROUTE))
 *   if mobile redirects current window to THIS component
 * -[COMPONENT FLOW A] Component redirects to WitbookingPaymentSystem (a.k.a. PAYMENT_ROUTE)
 *   We must pass Locale / Current Domain / Reservation ID / propertyTicker / Environment(dev, prod)?
 * -User fills CC data in WitbookingPaymentSystem
 * -WitbookingPaymentSystem redirect to either our success or fail state
 * -[COMPONENT FLOW B] If success
 *   if on desktop the browser window is closed (check for window.opener) and the parent is redirected to the confirmation page
 *   if on mobile the (window.opener is null) the component redirect to the confirmation page
 * -[COMPONENT FLOW C] If fail (how?) the user is shown an error message with a button to try again which redirects to WITBOOKING_PAYMENT_ROUTE and start over.
 */
class WitbookingPaymentBridge extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isChild: false,
    };
    this.redirectToWitbookingPaymentSystem = this.redirectToWitbookingPaymentSystem.bind(this);
    this.redirectToConfirmationPage = this.redirectToConfirmationPage.bind(this);
    this.closeSelf = this.closeSelf.bind(this);
    this.restartPaymentProcess = this.restartPaymentProcess.bind(this);
  }

  componentDidMount() {
    if (this.props.match && this.props.match.params && this.props.match.params.reservationId) {
      if (window && window.opener) {
        this.setState({ isChild: true });
      }
      if (this.props.match.params.status) {
        // TODO: if not needed delete
        // const domain = this.props.location.query.domain || constants.DEFAULT_HOST;
        switch (this.props.match.params.status) {
          case constants.PAYMENT_STATUS.SUCCESS:
            /* [COMPONENT FLOW B] Success status
             *  check for window.opener,
             *   if not null relative redirect parent to confirmation and close window
             *   if null relative redirect to confirmation
             */
            if (window && window.opener) {
              this.redirectToConfirmationPage({ isChild: true });
              this.closeSelf();
              return;
            }
            this.redirectToConfirmationPage({ isChild: false });
            return;
          case constants.PAYMENT_STATUS.FAILURE:
            /* [COMPONENT FLOW C] Failure status
               Do nothing here but render error message with button to start over (redirects current window to WITBOOKING_PAYMENT_ROUTE)
            */
            return;
          default:
            break;
        }
      }
      /* [COMPONENT FLOW A] Since there's no status we just redirect to WitbookingPaymentSystem */
      this.redirectToWitbookingPaymentSystem();
    }
  }

  closeSelf() {
    window.close();
  }

  redirectToWitbookingPaymentSystem() {
    const { hotelTicker: propertyTicker, reservationId, locale } = this.props.match.params;
    const queryParams =
      (this.props.location &&
        this.props.location.search &&
        queryStringParse(this.props.location.search)) ||
      {};
    const { propertyName, propertyCity } = queryParams;
    const domain = location.host;
    const queryString = `locale=${locale}&propertyTicker=${propertyTicker}&reservationId=${reservationId}&domain=${domain}&env=${
      process.env.NODE_ENV
    }&propertyName=${window.encodeURIComponent(
      propertyName
    )}&propertyCity=${window.encodeURIComponent(propertyCity)}`;
    const paymentConfiguration = window.__additionalData.WB_PAYMENT_URL;
    const url = `${paymentConfiguration.domain}/payments/witbooking?${queryString}`;
    redirectUrl(url);
  }

  redirectToConfirmationPage({ isChild }) {
    const { hotelTicker: propertyTicker, reservationId } = this.props.match.params;
    if (isChild) {
      redirectOpenerUrl(`/${propertyTicker}/booking-confirmation/${reservationId}`);
    } else {
      redirectUrl(`/${propertyTicker}/booking-confirmation/${reservationId}`);
    }
  }

  restartPaymentProcess({ isChild }) {
    const { hotelTicker: propertyTicker, reservationId, locale } = this.props.match.params;
    const queryParams =
      (this.props.location &&
        this.props.location.search &&
        queryStringParse(this.props.location.search)) ||
      {};
    const { propertyName, propertyCity } = queryParams;
    const url = `/${propertyTicker}/payments/${
      constants.PAYMENT_TYPES.WITBOOKING
    }/${locale}/${reservationId}?propertyName=${window.encodeURIComponent(
      propertyName
    )}&propertyCity=${window.encodeURIComponent(propertyCity)}`;
    if (isChild) {
      redirectUrl(url);
    } else {
      if (window.opener) {
        redirectOpenerUrl(url);
      } else {
        redirectUrl(url);
      }
    }
  }

  // This method will be executed twice, once without a reservationID just to open the popup window
  // avoiding popup blockers, and then a second time once the reservation has been created to point
  // the popup window to the correct URL
  startPaymentProcess({ propertyTicker, locale, reservationID, propertyName, propertyCity }) {
    if (window) {
      /*TODO: Make this a function or constant or global, DO NOT DUPLICATE*/
      // Check if we are in a mobile screen and replace the current window
      const mobileMode = window.innerWidth < 500;
      // if no reservation Id is given, we do not generate an url for the popup
      let url = "";
      if (reservationID) {
        url = `/${propertyTicker}/payments/${
          constants.PAYMENT_TYPES.WITBOOKING
        }/${locale}/${reservationID}?propertyName=${window.encodeURIComponent(
          propertyName
        )}&propertyCity=${window.encodeURIComponent(propertyCity)}`;
      }
      // if it's mobile mode but there's no url we do nothing.
      if (mobileMode && !url) {
        return;
      }

      // Replace the current window if we have a reservation ID and have a mobile screen
      if (mobileMode && url) {
        redirectUrl(url);
        return;
      }
      try {
        // Check if a window already exists (opened in the first call)
        if (!this.window) {
          // Callback to disable global loading overlay when the window closes
          const closeCallback = () => {
            this.props.toggleLoading(false);
            this.window = null;
          };
          // if no window exists try to open a popup window.
          this.window = openPopupWindow({ url, closeCallback });
        } else {
          // A window does exists point it to the correct url
          // since we are working in the same domain there's no problem in doing this
          redirectUrl(url);
        }
      } catch (error) {
        // could not open window, do full redirect on the Second Call
        // this may be inefficient as it tries to open the window Twice, failing twice.
        if (url) {
          redirectUrl(url);
        }
      }
    }
  }

  render() {
    /* Render is only useful if payment fails */
    if (
      !this.props.match ||
      !this.props.match.params ||
      !this.props.match.params.status ||
      this.props.match.params.status !== constants.PAYMENT_STATUS.FAILURE
    ) {
      return null;
    }
    const { restartPaymentProcess } = this;
    const { isChild } = this.state;
    return (
      <div className={classnames(styles.WitbookingPaymentBridge, styles.paymentErrorMessage)}>
        <div>
          <FormattedMessage {...msgs.errorOcurred} />
        </div>
        <button onClick={() => restartPaymentProcess({ isChild })}>
          <FormattedMessage {...msgs.tryAgain} />
        </button>
      </div>
    );
  }
}
WitbookingPaymentBridge.propTypes = {
  failedTransaction: PropTypes.object,
  propertyTicker: PropTypes.string,
  reservationId: PropTypes.string,
  depositTotal: PropTypes.number,
  params: PropTypes.object,
  intl: PropTypes.object,
  handleSuccess: PropTypes.func,
  handleFailure: PropTypes.func,
  chargeCurrency: PropTypes.string,
  propertyName: PropTypes.string,
  propertyContact: PropTypes.string,
  locale: PropTypes.string,
};

export default WitbookingPaymentBridge;
